import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/error'

const initialState = Immutable.fromJS({
  error: false,
})

export default handleActions({
  [actions.RESET_ERROR_MESSAGE] (state = null, action) {
    const { type, error } = action;
    if (type === actions.RESET_ERROR_MESSAGE) {
      return null;
    } else if (error) {
      return error;
    }
    return state;
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/error.js